import React, { useState } from "react";
import {
  IconButton,
  InputAdornment,
  Popover,
  TextField,
  Typography,
  styled,
} from "@mui/material";
import {
  CommonButton,
  CommonOutlinedButton,
  CustomInputLabel,
  CustomRequiredInputLabel,
  CustomTextFeild,
  CustomTimeOutlinedIcon,
} from "../StyledComponents/StyledFields";
import styles from "./hcccTimePicker.module.scss";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { isNil } from "lodash";

const CustomHoursTextFeild = styled(TextField)`
  .MuiFormControl-root {
    background-color: #fff;
    color: #f05802;
  }
  & input {
    background-color: #fff;
    width: 96px;
    padding: 14px 16px;
    border-radius: 5px;
    height: 80px;
    color: #f05802;
    border: 2px solid #f05802;
    text-align: center;
    font-size: 56px;
    font-style: normal;
    font-weight: 300;
    line-height: 74.5px;
  }
  & fieldset {
    border-style: unset;
    color: #f05802;
  }
  & div {
    background-color: #fff;
  }
  & svg {
    background-color: #fff;
  }
`;

const CustomMinutesTextFeild = styled(TextField)`
.MuiFormControl-root {
    background-color: rgba(33, 33, 33, 0.08);
    color: var(--00-on-surface-high-emphasis, rgba(0, 0, 0, 0.87));
 }
 & input {
    background-color: rgba(33, 33, 33, 0.08);
    width: 96px;
    padding: 14px 16px;
    border-radius: 5px;
    height: 80px;
    color: var(--00-on-surface-high-emphasis, rgba(0, 0, 0, 0.87));
    text-align: center;
    font-size: 56px;
    font-style: normal;
    font-weight: 400;
    line-height: 64px;
 }
 & fieldset {
    border-style: unset;
    color: var(--00-on-surface-high-emphasis, rgba(0, 0, 0, 0.87));
 }
 & div {
    background-color: rgba(33, 33, 33, 0.08));
 }
 & svg {
    background-color: rgba(33, 33, 33, 0.08));
 }
`;

const CustomToggleButton = styled(ToggleButtonGroup)(() => ({
  "& .MuiToggleButtonGroup-grouped": {
    border: "1px solid #DADCE0",
    borderRadius: "4px",
    "&:not(:first-of-type)": {
      border: "1px solid #DADCE0",
      backgroundColor: "#fff",
      "&.Mui-selected": {
        border: "1px solid #DADCE0",
        backgroundColor: "rgba(240, 88, 2, 0.20)", // Background color when selected
        color: "var(--Primary-Color, #F05802)",
        textAlign: "center", // Text alignment when selected
        fontFamily: "Roboto", // Font family when selected
        fontSize: "14px", // Font size when selected
        fontStyle: "normal", // Font style when selected
        fontWeight: 600, // Font weight when selected
        letterSpacing: "1.25px",
        textTransform: "uppercase",
      },
    },
    "&:first-of-type": {
      border: "1px solid #DADCE0",
      backgroundColor: "#fff",
      "&.Mui-selected": {
        color: "var(--Primary-Color, #F05802)",
        border: "1px solid #DADCE0",
        backgroundColor: "rgba(240, 88, 2, 0.20)", // Background color when selected
        textAlign: "center", // Text alignment when selected
        fontFeatureSettings: "'clig' off, 'liga' off", // Font feature settings when selected
        fontFamily: "Roboto", // Font family when selected
        fontSize: "14px", // Font size when selected
        fontStyle: "normal", // Font style when selected
        fontWeight: 600, // Font weight when selected
        letterSpacing: "1.25px", // Letter spacing when selected
        textTransform: "uppercase", // Text transform when selected
      },
    },
  },
}));

interface HcccTimePickerProps {
  labelName?: string;
  fieldName: string;
  setSelectedTime?: React.Dispatch<React.SetStateAction<string>>;
  onChange?: () => void;
  handleFieldChange: (field: string, value: any) => void;
  className?: string;
  value?:string;
}

const HcccTimePicker = (props: HcccTimePickerProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [formData, setFormData] = useState({
    hours: "",
    minutes: "00",
    session: "",
  });
  const [meridiem , setMeridiem ] = useState<string>("AM");
  const [selectedTime, setSelectedTime] = useState<string>("hh:mm");

  const getValue = ():string => {
    if(isNil(props.value)) {
      return selectedTime
    } else {
      return props.value
    }
  }

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleTimeSubmit = () => {
    const formattedTime = `${formData.hours}:${formData.minutes} ${meridiem }`;
    //   onChange(formattedTime);
    if (props.handleFieldChange) {
      props.handleFieldChange(props.fieldName, formattedTime);
    }

    handleClose();
    // props.setSelectedTime(formattedTime);
    setSelectedTime(formattedTime);
    console.log(formattedTime, "formattedTime");
  };

  const open = Boolean(anchorEl);
  const id = open ? "custom-time-picker" : undefined;

  const handleFieldChange = (field: string, value: any) => {
    // Check if the value is empty or consists of only numeric characters
    if (value === "" || /^\d+$/.test(value)) {
      if (field === "hours") {
        // Limit hours to 1-12
        const hours = Math.min(parseInt(value, 10) || 0, 12);
        setFormData({
          ...formData,
          [field]: hours.toString().padStart(2, "0"), // Ensure two-digit format
        });
      } else if (field === "minutes" ) {
        // Limit minutes to 0-59
        const minutes = Math.min(parseInt(value, 10) || 0, 59);
        setFormData({
          ...formData,
          [field]: minutes.toString().padStart(2, "0"), // Ensure two-digit format
        });
      }
    }
  };
const handleFocs =(field:string, value:any)=>{
  setFormData({
    ...formData,
    [field]:"" // Ensure two-digit format
  });
}
  const handleChangeSession = (
    _event: React.MouseEvent<HTMLElement>,
    nextView: string
  ) => {
    setMeridiem(nextView);
  };

  const handleCancel = () => {
    setSelectedTime("");
    handleClose();
  };

  const getClassName = (): string => {
    if (isNil(props.className)) {
      return "";
    } else {
      return props.className;
    }
  };
  const handleBlur = () => {
    // Restore previous session value when time field loses focus
    if (!meridiem ) {
      // Set session to default (e.g., "AM") if no session is selected
      setMeridiem("AM"); // Change this to your desired default value
    }
  };
  const popOverComponent = () => {
    return (
      <div className={styles.popOverContainer}>
        <div className={styles.headingContainer}>
          <Typography component={"p"} className={styles.popoverHeading}>
            Choose Time
          </Typography>
        </div>
        <div className={styles.fieldsContainer}>
          <div>
            <CustomHoursTextFeild
              value={formData.hours}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                handleFieldChange("hours", e.target.value);
              }}
              id="hrs"
            />
            <CustomInputLabel>Hours</CustomInputLabel>
          </div>
          <div className={styles.dotsContainer}>
            <span className={styles.dots}>:</span>
          </div>
          <div>
            <CustomMinutesTextFeild
              value={formData.minutes}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const numericValue = e.target.value.replace(/[^0-9]/g, "");
                handleFieldChange("minutes", numericValue);
              }}
              onFocus={(e) => {
                handleFocs("minutes", e.target.value);
              }}
              onBlur={(e) => {
                if (e.target.value.trim() === "") {
                  handleFieldChange("minutes", "00");
                }
              }}
              id="minutes"
            />
            <CustomInputLabel>Minutes</CustomInputLabel>
          </div>
          <div className={styles.sessionContainer}>
            <CustomToggleButton
              orientation="vertical"
              value={meridiem}
              exclusive
              onChange={handleChangeSession}
              onBlur={handleBlur} 
            >
              <ToggleButton value="AM" aria-label="AM">
                AM
              </ToggleButton>
              <ToggleButton value="PM" aria-label="PM">
                PM
              </ToggleButton>
            </CustomToggleButton>
          </div>
        </div>
        <div className={styles.actionContainer}>
          <CommonOutlinedButton onClick={handleCancel}>
            Cancel
          </CommonOutlinedButton>
          <CommonButton onClick={handleTimeSubmit} disabled={Number(formData?.hours) === 0}>Ok</CommonButton>
        </div>
      </div>
    );
  };

  const getLabelName = (): string => {
    if (isNil(props.labelName)) {
      return "Select Time";
    } else {
      return props.labelName;
    }
  };

  //    const getOnChange = ():void => {
  //     if(isNil(props.onChange)) {
  //         return handleTimeChange();
  //     } else {
  //         return props.onChange
  //     }
  //    }

  return (
    <div>
      {CustomRequiredInputLabel(`${getLabelName()}`, true)}
      <CustomTextFeild
        onClick={handleClick}
        fullWidth
        required
        value={getValue() === "" ? "hh:mm" : getValue()}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={handleClick}>
                <CustomTimeOutlinedIcon />
              </IconButton>
            </InputAdornment>
          ),
          readOnly: true,
        }}
        className={getClassName()}
        id="timepicker"
      />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
      >
        {popOverComponent()}
      </Popover>
    </div>
  );
};

export default HcccTimePicker;
